import * as v from 'valibot';
import {vxNumericInput} from "@root/server/client/esweb/src/lib/valibot/vx.ts";

export const rss_form_name = "app--rss-form";

export const RssFeedFormSchema = v.object({
    url: v.pipe(v.string(), v.url(), v.minLength(1)),
    interval_m: v.pipe(vxNumericInput(), v.minValue(5))
});

export type RssFeedFormValues = v.InferInput<typeof RssFeedFormSchema>;

export interface RssFeedFormProps {
    submitUrl: string;
    initialData?: Partial<RssFeedFormValues>;
}